module.exports = __webpack_public_path__ + "static/media/cloud-rain.710982c2.svg";